import { MouseEventHandler } from 'react';

import { BlueprintInstanceType } from '@rta/rta-blueprint-library';

import { contextMenuService } from './context-menu-service';
import { ReferenceEntryType } from './types/reference-entry-type.enum';

export type ContextMenuProps = {
	onMouseOver: MouseEventHandler<unknown>;
	onMouseOut: MouseEventHandler<unknown>;
};

export type AddContextMenuParams = {
	menuKey: ReferenceEntryType | BlueprintInstanceType;
	id?: string;
	center?: { x: number; y: number };
};

export const addContextMenu = ({ menuKey, id = null, center = { x: 0, y: 0 }}: AddContextMenuParams): ContextMenuProps => {
	return {
		onMouseOver: (e) => {
			e.stopPropagation();
			contextMenuService.setContext({
				menuKey,
				element: e,
				id,
				center
			});
		},
		onMouseOut: () => {
			contextMenuService.setContext({
				menuKey: ReferenceEntryType.Workspace,
				element: null,
				id: null
			});
		}
	};
};
